import React from 'react';
import { Phone, ArrowRight } from 'lucide-react'; // Changed ArrowRight to Phone for the CTA

const SHOP_PHONE = '+918441856072'; // Sardar Jewellers Phone Number

const SubscribePage = () => {
  return (
    <section className="bg-[#e2c6ab] py-16 px-6 text-center">
      <div className="max-w-2xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-semibold text-[#8B5E3C] mb-4 font-serif">
          Book a Free Consultation
        </h2>
        <p className="text-gray-600 text-sm md:text-base mb-8">
          Apne custom design ya bade purchase ke liye, hamare experts se seedhe baat karein.
        </p>

        {/* 🛑 Replaced Form/Input with a Direct Call Button (Anchor Tag) */}
        <div className="flex justify-center">
          <a
            href={`tel:${SHOP_PHONE}`} // Direct calling link
            className="bg-gradient-to-r from-[#8B5E3C] to-[#c49a6c] text-white px-8 py-3 rounded-full flex items-center gap-3 text-lg font-bold hover:scale-105 transition shadow-lg"
          >
            <Phone className="w-5 h-5" />
            Call Now: {SHOP_PHONE}
          </a>
        </div>
      </div>
    </section>
  );
};

export default SubscribePage;